module.exports = __webpack_public_path__ + "img/changyonggongneng.dfc795d1.png";